/**
 * Plugin que expone pseudo-pipes globales tz-aware en templates:
 *   {{ $date(appt.starts_at) }}        → "martes, 21 de abril de 2026"
 *   {{ $dateShort(appt.starts_at) }}   → "21 abr 2026"
 *   {{ $dateNumeric(appt.starts_at) }} → "21/04/2026"
 *   {{ $time(appt.starts_at) }}        → "14:30"
 *   {{ $dt(appt.starts_at) }}          → "21 abr 2026, 14:30"
 *   {{ $weekdayShort(appt.starts_at) }}→ "mar"
 *   {{ $tzFormat(iso, 'yyyy-MM-dd') }} → patrón date-fns libre
 *
 * Todos usan `clinics.timezone` del settings store. En scripts preferir
 * `useClinicDateTime()` para acceso reactivo.
 */
import { useSettingsStore } from '~/stores/settings'
import * as dt from '~/utils/datetime'

export default defineNuxtPlugin(() => {
  const getTz = () => useSettingsStore().clinic?.timezone ?? dt.DEFAULT_TZ

  return {
    provide: {
      date:         (iso: string | Date | null | undefined, pattern?: string) => dt.formatDate(iso, getTz(), pattern),
      dateShort:    (iso: string | Date | null | undefined) => dt.formatDateShort(iso, getTz()),
      dateNumeric:  (iso: string | Date | null | undefined) => dt.formatDateNumeric(iso, getTz()),
      time:         (iso: string | Date | null | undefined, pattern?: string) => dt.formatTime(iso, getTz(), pattern),
      dt:           (iso: string | Date | null | undefined, pattern?: string) => dt.formatDateTime(iso, getTz(), pattern),
      weekdayShort: (iso: string | Date | null | undefined) => dt.formatWeekdayShort(iso, getTz()),
      tzFormat:     (iso: string | Date | null | undefined, pattern: string) => dt.formatTz(iso, getTz(), pattern),
      clinicTz:     () => getTz(),
    },
  }
})
